module.exports = __webpack_public_path__ + "media/images/sandbox/rondell/rondell-5-2c9128371786b9a054e703268a16d891.jpg";